export type IndustryExperienceLevel =
  | ""
  | "0 years"
  | "Less than 1 year"
  | "1-2 years"
  | "3-5 years"
  | "6+ years";

export type FreeHelpQualificationResult =
  | "qualified"
  | "student_qualified"
  | "needs_skool"
  | "work_authorization";

const AUTHORIZED_WITHOUT_SPONSORSHIP =
  "Yes, I'm authorized to work in the U.S. or Canada and won't need sponsorship";
export const RECENT_GRADUATE_SITUATION = "Recent or new college graduate";
export const STUDENT_SITUATIONS = [
  "College student looking for an internship",
  RECENT_GRADUATE_SITUATION,
  "Working in tech, but not as a software engineer",
  "Career changer trying to become a software engineer",
] as const;

export const hasMinimumIndustryExperience = (
  experienceLevel: IndustryExperienceLevel
) =>
  experienceLevel === "1-2 years" ||
  experienceLevel === "3-5 years" ||
  experienceLevel === "6+ years";

export const getFreeHelpQualificationResult = ({
  industryExperienceLevel,
  isUsCanadaEngineer,
  workAuthorizationStatus,
  hasSolved100DsaProblems,
  currentSituation,
  investmentReadiness,
}: {
  industryExperienceLevel: IndustryExperienceLevel;
  isUsCanadaEngineer: "yes" | "no" | "";
  workAuthorizationStatus: string;
  hasSolved100DsaProblems: "yes" | "no" | "";
  currentSituation: string;
  investmentReadiness: string;
}): FreeHelpQualificationResult => {
  if (isUsCanadaEngineer !== "yes") {
    return "needs_skool";
  }

  if (workAuthorizationStatus !== AUTHORIZED_WITHOUT_SPONSORSHIP) {
    return "work_authorization";
  }

  if (
    investmentReadiness === "No, I'm only looking for free help right now"
  ) {
    return "needs_skool";
  }

  if (
    !hasMinimumIndustryExperience(industryExperienceLevel) ||
    hasSolved100DsaProblems !== "yes" ||
    STUDENT_SITUATIONS.includes(
      currentSituation as (typeof STUDENT_SITUATIONS)[number]
    )
  ) {
    return "student_qualified";
  }

  return "qualified";
};
